import './_discount-field.scss';
import {fetchCartSectionAndUpdate} from 'snippets/cart-js/cart-helpers';

const APPLY_DISCOUNT_BUTTON = '.discount-field-wrapper > button';

class DiscountField extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const inputElement = this.querySelector('input');
        inputElement.addEventListener('input', (e) => {
            const discountCode = e.target.value;
            if(discountCode) {
                this.querySelector(APPLY_DISCOUNT_BUTTON).removeAttribute('disabled');
            } else {
                this.querySelector(APPLY_DISCOUNT_BUTTON).setAttribute('disabled', 'disabled');
            }
        });

        this.querySelector(APPLY_DISCOUNT_BUTTON).addEventListener('click', (e) => {
            e.preventDefault();
            this.applyDiscountCode(inputElement.value);
        });

        this.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if(inputElement.value) {
                    this.applyDiscountCode(inputElement.value);
                }
            }
        });
    }

    applyDiscountCode(code) {
        if(code.length) {
            fetch(window.localeUrl + '/discount/' + code)
                .then(async (res) => {
                    if(res.ok) {
                        await fetchCartSectionAndUpdate();
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
        }
    }
}

customElements.define('discount-field', DiscountField);
